import useAuth from '@app/auth/use-auth';
import useUpsellDialog from '@app/hooks/use-upsell-dialog';
import { pcfRoutes } from '@app/pcf/pcf-routes';
import { useNavigate } from 'react-router-dom';

const useHandleCreateNewProductAction = () => {
  const navigate = useNavigate();
  const { showDialog, UpsellDialogComponent } = useUpsellDialog();
  const { user } = useAuth();

  const handleCreateNewProductAction = () => {
    if (
      user?.organizationPlan === 'free' &&
      user?.organizationProductLimit &&
      user?.organizationProductLimit <= user?.numberOfProducts
    ) {
      showDialog();
    } else {
      navigate(pcfRoutes.PRODUCTS_CREATE);
    }
  };

  return {
    handleCreateNewProductAction,
    UpsellDialogComponent,
  };
};

export default useHandleCreateNewProductAction;
